import { createSlice } from '@reduxjs/toolkit'
import { getServices, getServicesAdmin, getUserServices } from "./thunks"

const initialState= { 
  list: {
    pageIndex: 0,
    totalRecords: 15,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  services:[],
  userServices:[], 
  loadingList: "idle",
  loadingServices: "idle",
  loadingUserServices: "idle",
  error: null 
}

const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearServiceError:(state)=>{
      state.error= null
    },
    setServiceFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [getServicesAdmin.pending]: (state)=>{
      state.loadingList = "loading";
      state.error = null
    },
    [getServicesAdmin.fulfilled]: (state, action) =>{
      state.list = action.payload;
      state.loadingList = "succeeded"
    },
    [getServicesAdmin.rejected]: (state, action) =>{
      state.loadingServices = "failed";
      state.error = action.error.message
    },
    [getServices.pending]: (state)=>{
      state.loadingServices = "loading";
      state.error = null
    },
    [getServices.fulfilled]: (state, action) =>{
      state.services = action.payload;
      state.loadingServices = "succeeded"
    },
    [getServices.rejected]: (state, action) =>{
      state.loadingServices = "failed";
      state.error = action.error.message
    },
    [getUserServices.pending]: (state)=>{
      state.loadingServices = "loading";
      state.error = null
    },
    [getUserServices.fulfilled]: (state, action) =>{
      state.userServices = action.payload;
      state.loadingUserServices = "succeeded"
    },
    [getUserServices.rejected]: (state, action) =>{
      state.loadingUserServices = "failed";
      state.error = action.error.message
    }
  }
})

export const {clearServiceError, setServiceFilters} = serviceSlice.actions

export default serviceSlice.reducer
